import type {
  ConfirmationCallback as ConfirmationAPICallback,
  Confirmations as ConfirmationsAPI,
} from 'utils/confirmations';
import type { Game } from 'chessboard/model/game/types';
import type { GameAPI } from 'chessboard/types';
import type { MoveList } from 'chessboard/model/move-list/types';

export namespace ContextMenu {
  export interface API {
    destroy(): void;
  }

  export interface Action {
    /**
     * The action to emit when this is clicked.
     */
    action: string;

    /**
     * The handler for the action
     */
    handler: (
      context: ContextMenu.ActionHandlerContext,
      payload?: ContextMenu.HandlerPayload<any>,
    ) => void;

    /**
     * A condition determining whether or not to show this action in the context menu
     */
    isVisible: (context: ContextMenu.ActionHandlerContext) => boolean;

    /**
     * The display name of the action in the menu.
     */
    getDisplayName: (context: ContextMenu.ActionHandlerContext) => string;
  }

  /**
   * The potential keys to change on the context menu
   */
  export enum Keys {
    Actions = 'actions',
    Translations = 'translations',
  }

  export interface ActionHandlerContext {
    game: GameAPI;
    node: Game.Move.Node;
  }

  /**
   * The params passed to a context menu handler
   */
  export interface HandlerPayload<Data> {
    data: Data;
  }

  export namespace Plugin {
    export const Name = 'contextMenu';

    export interface API extends Confirmations {}

    export type Confirmations = ConfirmationsAPI<string, { event: Event }>;
    export type ConfirmationCallback = ConfirmationAPICallback<string, { event: Event }>;
  }
}

export namespace ContextMenuComponent {
  export interface Props {
    [ContextMenu.Keys.Actions]: ContextMenu.Action[];
    [ContextMenu.Keys.Translations]: MoveList.Translations;
  }

  export enum Classes {
    ActionName = 'action-name',
    Annotation = 'annotation',
    ActionsContainer = 'actions-container',
    AnnotationsContainer = 'annotations-container',
    Component = 'move-node-context-menu', // eslint-disable-line
    Divider = 'divider',
  }
}
